import React from 'react';
import { Box, Divider, Stack, Typography, styled } from '@mui/material';
import { Link } from 'react-router-dom';
import { MobileHeader1 } from '@theme/styledComponents';
import { styledConstants } from '@theme/styledConstants';

const StyledPageBox = styled(Box)(({ theme }) => ({
  minHeight: '100vh',
  backgroundColor: theme.palette.background.paper,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(4),
}));

const StyledDivider = styled(Divider)({
  marginTop: '5rem',
});

const StyledFooterBox = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(2),
}));

type MobilePageContainerProps = {
  children: React.ReactNode;
  title: string;
  footerText?: string;
  footerUrl?: string;
};

export const MobilePageContainer = ({ children, title, footerText, footerUrl }: MobilePageContainerProps) => {
  return (
    <StyledPageBox>
      <MobileHeader1>
        {title}
      </MobileHeader1>

      <Box mt={styledConstants.Header2TopMargin}>
        {children}
      </Box>

      {footerText && footerUrl && (
        <>
          <StyledDivider />
          <StyledFooterBox>
            <Link to={footerUrl}>
              <Typography textAlign="center">{footerText}</Typography>
            </Link>
          </StyledFooterBox>
        </>
      )}
    </StyledPageBox>
  );
};
